
import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {LogoImageDefaultBoxCasino777} from "./logo-image.casino777.box";
import {LogoImageDefaultBoxHarringtonDelaware} from "./logo-image.harrington.delaware.box";
import {LogoImageDefaultBallysDover} from "./logo-image.ballysdover.box";
import {LogoImageDefaultWSOP} from "./logo-image.wsop.box";
import {LogoImageDefaultHarrash} from "./logo-icon.harrahs.box";
import {LogoImageDefaultBox} from "./logo-image.default.box";
import {LogoImageSiBox} from "./logo-image.si.box";
import {LogoImageMrgreenBox} from "./logo-image.mrgreen.box";

export const LogoImageBox = styledByTheme(LogoImageDefaultBox)
                            .forCasino777(LogoImageDefaultBoxCasino777)
                            .forHarrington(LogoImageDefaultBoxHarringtonDelaware)
                            .forDelawarePark(LogoImageDefaultBoxHarringtonDelaware)
                            .forBallysDover(LogoImageDefaultBallysDover)
                            .forWsop(LogoImageDefaultWSOP)
                            .forHarrahs(LogoImageDefaultHarrash)
                            .forSI(LogoImageSiBox)
                            .forMrGreen(LogoImageMrgreenBox)
                            .apply();
